export default {
  APPFRAMEWORK: "AppFramework",
}